.item {
  display: flex;
  align-items: center;
  border-radius: var(--mantine-radius-md);
  border: 1px solid
    light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-5));
  padding: var(--mantine-spacing-xs);
  background-color: light-dark(
    var(--mantine-color-white),
    var(--mantine-color-dark-5)
  );
  margin-bottom: var(--mantine-spacing-xs);
  justify-content: space-between;
}

.itemDragging {
  box-shadow: var(--mantine-shadow-sm);
}

.dragHandle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-1));
}
